import React, { useEffect, useState } from "react";
function SetLocale({ children }) {
    const[current_lang,setCurrentLang] = useState('en')
    useEffect(() => {
        const path = window.location.pathname;
        const lang = path.split("/")[1];
        if (lang === 'en') {
            setCurrentLang('en')
        }else{
            setCurrentLang('ar')
        }
        if (lang === "en") {
            localStorage.setItem("current_lang", "en");
        }else{
            localStorage.setItem("current_lang", 'ar');
        }

    }, []); 
    return <>
          <div  className={current_lang == "ar" ? "arabic" : "english"}>
                {children}
         </div>
        </>;
}

export default SetLocale;
